/** @jsx h */
import { h, Component, JSX } from 'preact';
import style from '../common/shared-style.css';
import { RootStore } from '../../../../../common/js/stores/root.store';
import { hexToRGBA } from '../../../../../common/js/colors';
import cn from 'classnames';
import { triggerMraidClose } from '../../../lib/actions';
import OptOutIcon from '../../../../../common/components/opt-out/icon';
import { CTAOverlay } from '../../../../../common/components/cta-overlay';

interface EndScreenCTAControlsProps {
  onOptout: () => void;
  onCTAClick: (e: MouseEvent) => void;
}

class EndScreenCTAControls extends Component<EndScreenCTAControlsProps> {
  componentDidMount(): void {
    const videoStore = RootStore.getInstance().videoStore;

    const { isVideoExpanded } = videoStore;

    if (isVideoExpanded.value) {
      // Will close the "expanded" state of the ad
      triggerMraidClose({
        force: false
      });
    }
  }

  render(): JSX.Element {
    const { onOptout, onCTAClick } = this.props;
    const controlsStore = RootStore.getInstance().controlsStore;
    const configStore = RootStore.getInstance().configStore;

    const { config } = configStore;
    const controlsBackgroundColor = config.controlsBackgroundColor;
    const controlsBackgroundOpacity = config.controlsBackgroundOpacity;

    const optOutPositionStyle = {
      right: 0,
      left: 'auto'
    };

    const backgroundStyle: h.JSX.CSSProperties = {
      background: hexToRGBA(
        controlsBackgroundColor ? controlsBackgroundColor : '#28323c',
        controlsBackgroundOpacity ? controlsBackgroundOpacity / 100 : 0.5
      ) as string,
      width: '20px',
      height: '20px',
      borderRadius: '4px'
    };

    const optOutItem = (
      <div className={style.optout} style={optOutPositionStyle}>
        <OptOutIcon
          iconSize={12}
          onClick={onOptout}
          isInterstitialAdUnit={false}
          style={backgroundStyle}
        />
      </div>
    );

    return (
      <div
        data-zone="end-screen-cta-controls"
        className={style.ctaControlsContainer}
      >
        <CTAOverlay onClick={onCTAClick} />

        <div className={cn(style.controlsRow, style.bottomControls)}>
          {controlsStore.shouldDisplayOptOut() ? optOutItem : <div />}
        </div>
      </div>
    );
  }
}

export default EndScreenCTAControls;
